import { Badge } from "@mantine/core";
import { useIsPendingWithdraw } from "src/generator/hooks/useIsPendingWithdraw";
import useNonMaritime from "../../../hooks/useNonMaritime";

interface IStatusBadge {
  status: number | string;
  size?: string;
  variant?: string;
  autosave?: number;
  id?: string;
}

export const statusList: Record<number, any> = {
  0: { label: "Draft", color: "red.9" },
  1: { label: "Open", color: "orange.4" },
  2: { label: "Re-Verify", color: "orange.4" },
  3: { label: "Yacht Verified", color: "green.8" },
  4: { label: "Audit" },
  50: { label: "Pending Audit", miw: 120 },
  200: { label: "Internal Audit Verified", miw: 150 },
  210: { label: "Superintendent Visit Verified", miw: 200 },
  220: { label: "Manager Visit Verified", miw: 150 },
  230: { label: "Periodic Inspection Verified", miw: 200 },
  240: { label: "Management Review", miw: 120 },
  250: { label: "Yacht Review", miw: 120 },
  1000: { label: "Audit" },
  5: { label: "Further Info Requested", miw: 200 },
  6: { label: "Further Info Provided", miw: 200 },
  99: { label: "Withdrawn", miw: 200 },
};

const StatusBadge = ({
  status,
  size = "lg",
  variant = "light",
  autosave,
  id,
}: IStatusBadge) => {
  const isPendingWithdraw = useIsPendingWithdraw(id);
  const { replaceMaritimeText } = useNonMaritime();

  if (isPendingWithdraw) {
    return (
      <Badge variant={variant} size={size} color="red" py={10} miw={80}>
        To Withdraw
      </Badge>
    );
  }

  if (typeof status === "string") {
    return (
      <Badge variant={variant} size={size} color={"blue"} py={10} miw={80}>
        {status}
      </Badge>
    );
  }

  const item = { ...statusList[status] };
  if (!item) return <></>;
  // if (autosave && status === 0) item.label = "draft";
  return (
    <Badge
      variant={variant}
      size={size}
      color={item.color ?? "blue"}
      py={10}
      miw={item.miw ?? 100}>
      {replaceMaritimeText(item.label)}
    </Badge>
  );
};

export default StatusBadge;
